<script>
import { Navigation, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/svelte';
import {fade, fly} from 'svelte/transition'
import {push, pop, replace} from 'svelte-spa-router'
import {Button, Form, TextInput, Select, SelectItem, Checkbox, DatePicker, DatePickerInput} from 'carbon-components-svelte';
import OtpInput from 'svelte-otp'
import {getUserData} from '../userdata.js'

import {Motion, M} from 'svelte-motion'
import { getAuth, signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
import {itemB} from './animations.js'
import Tailwindcss from '../Tailwind.svelte'
import {animateScroll} from 'svelte-scrollto-element'
import { registerUser } from '../auth';
import {getCountries}  from '../userdata'
import {_} from 'svelte-i18n'
import {auth} from '../firebase.js'

/* import {itemB} from './animations' */
import {sessionData} from '../stores'
import { onMount } from 'svelte';

  function switchOffLooking(){


      $sessionData.chessConsoleApp.webSocketConnection.close()
      $sessionData.chessConsoleApp.showHome()

    }


</script>




<Tailwindcss/>


<div in:fly={{x: 20}} on:click={switchOffLooking} out:fade class="cursor-pointer play-button-active">
      <div class="flex gap-x-4 flex-row mx-auto">
        <h2 class="text-xl4 my-auto text-black animate-pulse">{$_('common.looking')}</h2>
      <div class="my-auto facespinner">
      <div class="facespinner__eye"></div>
      </div>

    </div>

      <div style="right: 3rem" class="rounded-full w-6 h-6 absolute -top-2 animate-ping bg-white"></div>

    </div>







<style>
 div.facespinner {
	 width: 2rem;
	 height: 2rem;
	 border: 2px solid #fff;
	 border-radius: 2.2rem;
	 display: flex;
	 justify-content: center;
}
 div.facespinner__eye {
	 width: 1rem;
	 position: relative;
	 transform: translate(-50%, 20%);
	 animation: facespinner 2s infinite cubic-bezier(0.76, 0, 0.24, 1) both;
}
 div.facespinner__eye:before, div.facespinner__eye:after {
	 content: '';
	 left: 0;
	 width: 0.3rem;
	 height: 0.8rem;
	 border-radius: 0.8rem;
	 position: absolute;
	 background-color: #000;
	 animation: facespinnereye 1.5s 1s infinite;
}
 div.facespinner__eye:after {
	 left: inherit;
	 right: 0;
}
 @keyframes facespinner {
	 0% {
		 transform: translate(-50%, 20%);
	}
	 30% {
		 transform: translate(0%, 30%);
	}
	 60% {
		 transform: translate(50%, 20%);
	}
	 80% {
		 transform: translate(0%, 30%);
	}
}
 @keyframes facespinnereye {
	 0% {
		 transform: scaleY(1);
	}
	 80% {
		 transform: scaleY(1);
	}
	 85% {
		 transform: scaleY(0);
	}
	 90% {
		 transform: scaleY(1);
	}
	 95% {
		 transform: scaleY(0);
	}
}

.play-button-active{

  opacity: 1;
  transform: translateY(0px);

  position: absolute;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  box-shadow: 0rem 0 1rem #000;
  transition-delay: 3s;
  transition: 0.5s;
  bottom: 0px;
  left: -25%;
  height: 4.5rem;
  width: 150%;
  /* background-color: #212229; */
  background-color: #FAE264;

  font-size: 2rem;
  color: white;
  /* margin: auto; */

  /* background-color: yellow; */

}
</style>
